// extracted by mini-css-extract-plugin
module.exports = {"right_menu":"index_right_menu__2bZgJ","custom_menu":"index_custom_menu__1xGS3","divider":"index_divider__3WFv_"};